export enum CoreGoogleUserTrackingConflictType {
    Unknown = 0,
    TrackingKey = 1,
    SourceObjectType = 2,
    Identifier = 3,
    EmailAddress = 4,
}

export interface CoreGoogleUserTrackingConflict {
    type: CoreGoogleUserTrackingConflictType
    trackingId: string
    flowSyncId: string
    displayName: string
    active: boolean
    sourceName: string
    sourceEnvironment: string
    sourceObjectType: string
    sourceIdentifier: string
}

export interface CoreGoogleUserTrackingUpdate {
    primaryEmail: string
}

export interface CoreGoogleUserTrackingMapping {
    googleId: string
    primaryEmail?: string
}

export enum CoreEntraIdUserTrackingConflictType {
    Unknown = 0,
    TrackingKey = 1,
    SourceObjectType = 2,
    Identifier = 3,
    EmailAddress = 4,
    UserPrincipalName = 5,
    GraphEmailAddress = 6,
    GraphUserPrincipalName = 7,
}

export interface CoreEntraIdUserTrackingFlowSyncConflict {
    type: CoreEntraIdUserTrackingConflictType.TrackingKey
        | CoreEntraIdUserTrackingConflictType.SourceObjectType
        | CoreEntraIdUserTrackingConflictType.Identifier
        | CoreEntraIdUserTrackingConflictType.EmailAddress
        | CoreEntraIdUserTrackingConflictType.UserPrincipalName
    trackingId: string
    flowSyncId: string
    displayName: string
    active: boolean
    sourceName: string
    sourceEnvironment: string
    sourceObjectType: string
    sourceIdentifier: string
}

export interface CoreEntraIdUserTrackingGraphConflict {
    type: CoreEntraIdUserTrackingConflictType.GraphEmailAddress
        | CoreEntraIdUserTrackingConflictType.GraphUserPrincipalName
    entraIdId: string
    displayName: string
    userPrincipalName: string
}

export type CoreEntraIdUserTrackingConflict = CoreEntraIdUserTrackingFlowSyncConflict | CoreEntraIdUserTrackingGraphConflict | { type: CoreEntraIdUserTrackingConflictType.Unknown }

export interface CoreEntraIdUserTrackingUpdate {
    userPrincipalName: string
    primarySmtpAddress: string
}

export interface CoreEntraIdUserTrackingMapping {
    entraIdId: string
    userPrincipalName: string
    primarySmtpAddress: string
}

export enum CoreAsmUserTrackingConflictType {
    Unknown = 0,
    TrackingKey = 1,
    SourceObjectType = 2,
    Identifier = 3,
}

export interface CoreAsmUserTrackingConflict {
    type: CoreAsmUserTrackingConflictType
    trackingId: string
    flowSyncId: string
    displayName: string
    active: boolean
    sourceName: string
    sourceEnvironment: string
    sourceObjectType: string
    sourceIdentifier: string
}

export interface CoreAsmUserTrackingMapping {
    asmId: string
}

export interface CoreOneRosterMappingTracking {
    flowSyncId: string
    trackingId: string
    sourceSystemId: string
    schoolUnitTitle: string
    displayName: string
    inactivated: string
}

export interface OneRosterTrackingSearchRequest {
    onlyInactive: boolean
    search?: string
    selfObjectId: string
}